import { InstructionTypes } from '../../Constants'
import { Instruction } from './Instruction'

export class ClickButtonInstruction extends Instruction {
  constructor ({ name, waitForNoLoaders, className, isVisible, click }) {
    super({ name, waitForNoLoaders, type: InstructionTypes.ClickButton })
    this.className = className
    this.isVisible = isVisible
    this.click = click
  }

  prepareInstruction (id, params) {
    this.id = id
  }

  getParsedInstruction () {
    return {
      ...super.getParsedInstruction(),
      className: this.className,
      isVisible: this.isVisible,
      click: this.click
    }
  }
}
